import { tifRoles } from '../../constants/user';
import { getTifModule } from '../../helpers/user';
import { isSelectedProject } from '../../helpers/CanAccess';
import { checkIfFeatureIsDisabled } from '../../constants/roles';
import { checkPermission } from '../../permissions/usePermissions';

const config = {
  cadd: [
    {
      name: "Dashboard Title",
      icon: "DashboardDashboard",
      path: "/app/cadd",
      visible: (user) => {
        return checkPermission({ permission: 'dashboard.canView', permissions: user?.role?.permissions })
      },
      demo: true,
      type: "link",
      isDashboard: true,
    },
    {
      name: 'My Organisation',
      visible: (user, project) => {
        return checkPermission({ permission: 'myOrganisation.canView', permissions: user?.role?.permissions }) && (!project || !project.id) ? true : false;
      },
      isModule: true,
      icon: "DashboardOwnOrg",
      type: "button",
      open: false,
      demo: true,
      isModule: true,
      items: [
        {
          name: "KYC",
          path: '/app/cadd/analysis/kyc/user',
          visible: (user, project) => {
            return checkPermission({ permission: 'myOrganisation.KYC.canView', permissions: user?.role?.permissions }) && (!project || !project.id) ? true : false;
          },
          isDisabled: (user, project) => {
            return !(project || project?.id);
          },
          demo: true,
          type: "link",
          subPath: [
            "/app/cadd/view/kyc/user/:id",
            '/app/cadd/analysis/kyc',

            "/app/cadd/view/kyc/user/:id",
            "/app/cadd/view/kyc/:id/:group",
            "/app/cadd/view/kyc/:id/:group/:subsection",
            "/app/cadd/view/kyc/:id/:group/:subsection/:subgroup",

            "/app/cadd/edit/kyc/user/:id",
            "/app/cadd/edit/kyc/:id/:group",
            "/app/cadd/edit/kyc/:id/:group/:subsection",
            "/app/cadd/edit/kyc/:id/:group/:subsection/:subgroup",
          ]
        },
        {
          name: "DD Systems",
          icon: "folder-shield-2-line",
          type: "button",
          demo: true,
          visible: (user, project) => {
            return checkPermission({ permission: 'myOrganisation.DDSystems.canView', permissions: user?.role?.permissions }) && (!project || !project.id) ? true : false;
          },
          isDisabled: (user, project) => {
            return !(project || project?.id);
          },
          open: false,
          path: "/app/cadd/analysis/sp",
          onTitleClick: 'PUSH_TO_DD_ANALYSIS',
          items: [
            {
              name: "Supply Chain Policy",
              icon: "file-paper-2-line",
              type: "link",
              demo: true,
              isDisabled: (user) => {
                return false;
              },
              visible: (user) => {
                return checkPermission({ permission: 'myOrganisation.DDSystems.SCP.canView', permissions: user?.role?.permissions })
              },
              path: "/app/cadd/viewdd/sp/user/",
              subPath: [
                "/app/cadd/viewdd/sp/user/:id",
                "/app/cadd/editdd/sp/user/:id",
              ]
            },
            {
              name: "Internal Management",
              icon: "layout-masonry-line",
              type: "link",
              demo: true,
              isDisabled: (user) => {
                return false;
              },
              visible: (user) => checkPermission({ permission: 'myOrganisation.DDSystems.internalManagement.canView', permissions: user?.role?.permissions }),
              path: "/app/cadd/viewdd/im/user",
              subPath: [
                "/app/cadd/viewdd/im/user/:id",
                "/app/cadd/editdd/im/user/:id",
              ]
            },
            {
              name: "Supply Chain Integrity",
              icon: "flow-chart",
              type: "link",
              demo: true,
              isDisabled: (user) => {
                return false;
              },
              visible: (user) => checkPermission({ permission: 'myOrganisation.DDSystems.SCI.canView', permissions: user?.role?.permissions }),
              path: "/app/cadd/viewdd/sci/user",
              subPath: [
                "/app/cadd/viewdd/sci/user/:id",
                "/app/cadd/editdd/sci/user/:id",
              ]
            },
            {
              name: "Supplier Engagement",
              icon: "contacts-book-2-line",
              type: "link",
              demo: true,
              isDisabled: (user) => {
                return false;
              },
              visible: (user) => {
                return checkPermission({ permission: 'myOrganisation.DDSystems.supplierEngagement.canView', permissions: user?.role?.permissions })
              },
              path: "/app/cadd/viewdd/bpe/user",
              subPath: [
                "/app/cadd/viewdd/bpe/user/:id",
                "/app/cadd/editdd/bpe/user/:id",
              ]
            },
            {
              name: "Grievance Mechanism",
              icon: "user-voice-line",
              type: "link",
              demo: true,
              isDisabled: (user) => {
                return false;
              },
              visible: (user) => checkPermission({ permission: 'myOrganisation.DDSystems.grievanceMechanism.canView', permissions: user?.role?.permissions }),
              path: "/app/cadd/viewdd/gm/user",
              subPath: [
                "/app/cadd/viewdd/gm/user/:id",
                "/app/cadd/editdd/gm/user/:id",
              ]
            },
          ],
        },
        // {
        //   name: "Shipments",
        //   icon: "BarcodeOutlined",
        //   visible: (user, project) => {
        //     return (!project || !project.id) ? true : false;
        //   },
        //   isDisabled: (user, project) => {
        //     return checkIfFeatureIsDisabled({ user, module: "cadd", feature: "shipments" }) ? true : (!project || !project.id)
        //   },
        //   path: "/app/cadd/shipments",
        //   type: "link"
        // },
      ]
    },
    {
      isModule: true,
      name: 'Stakeholders',
      visible: (user, project) => {
        return checkPermission({ permission: 'stakeholders.canView', permissions: user?.role?.permissions }) && isSelectedProject(user)
      },
      icon: "DashboardStakeholder",
      isModule: true,
      type: "button",
      open: false,
      demo: true,
      items: [
        {
          name: "Supply Chain Actors",
          visible: (user) => {
            return checkPermission({ permission: 'stakeholders.SCA.canView', permissions: user?.role?.permissions })
          },
          demo: true,
          ellipsis: true,
          icon: "NodeIndexOutlined",
          type: "link",
          path: "/app/cadd/scp",
          subPath: [
            "/app/cadd/scp/:id",
            "/app/cadd/scp/:id/locations",
            '/app/cadd/analysis/scp/:id',
            '/app/cadd/analysis/scp/:id/:sourceId',

            "/app/cadd/view/scp/:id",
            "/app/cadd/view/scp/:id/:group",
            "/app/cadd/view/scp/:id/:group/:subsection",
            "/app/cadd/view/scp/:id/:group/:subsection/:subgroup",
            "/app/cadd/view/scp/:id/:group/:subsection/:subgroup/:formid",

            "/app/cadd/edit/scp/:id",
            "/app/cadd/edit/scp/:id/:group",
            "/app/cadd/edit/scp/:id/:group/:subsection",
            "/app/cadd/edit/scp/:id/:group/:subsection/:subgroup",
            "/app/cadd/edit/scp/:id/:group/:subsection/:subgroup/:formid",
          ]
        },
        {
          name: "Local Information Relays",
          visible: (user, project) => {
            return checkPermission({ permission: 'stakeholders.LIR.canView', permissions: user?.role?.permissions }) && isSelectedProject(user)
          },
          demo: true,
          icon: "EyeOutlined",
          type: "link",
          path: "/app/cadd/lir",
          subPath: [
            "/app/cadd/lir/:id",

            "/app/cadd/view/lir/:id",
            "/app/cadd/view/lir/:id/:group",
            "/app/cadd/view/lir/:id/:group/:subsection",
            "/app/cadd/view/lir/:id/:group/:subsection/:subgroup",
            "/app/cadd/view/lir/:id/:group/:subsection/:subgroup/:formid",

            "/app/cadd/edit/lir/:id",
            "/app/cadd/edit/lir/:id/:group",
            "/app/cadd/edit/lir/:id/:group/:subsection",
            "/app/cadd/edit/lir/:id/:group/:subsection/:subgroup",
            "/app/cadd/edit/lir/:id/:group/:subsection/:subgroup/:formid",
          ]
        },
        {
          name: "Other",
          visible: (user, project) => {
            return checkPermission({ permission: 'stakeholders.canView', permissions: user?.role?.permissions }) && isSelectedProject(user)
          },
          demo: true,
          icon: "TeamOutlined",
          type: "link",
          path: "/app/cadd/stakeholders",
          subPath: [
            "/app/cadd/stakeholders/:id",

            "/app/cadd/view/stakeholder/:id",
            "/app/cadd/view/stakeholder/:id/:group",
            "/app/cadd/view/stakeholder/:id/:group/:subsection",
            "/app/cadd/view/stakeholder/:id/:group/:subsection/:subgroup",
            "/app/cadd/view/stakeholder/:id/:group/:subsection/:subgroup/:formid",

            "/app/cadd/edit/stakeholder/:id",
            "/app/cadd/edit/stakeholder/:id/:group",
            "/app/cadd/edit/stakeholder/:id/:group/:subsection",
            "/app/cadd/edit/stakeholder/:id/:group/:subsection/:subgroup",
            "/app/cadd/edit/stakeholder/:id/:group/:subsection/:subgroup/:formid",
          ]
        },
      ]
    },
    {
      isModule: true,
      name: 'Locations',
      isModule: true,
      visible: (user, project) => {
        return checkPermission({ permission: 'locations.canView', permissions: user?.role?.permissions }) && isSelectedProject(user)
      },
      icon: "DashboardLocations",
      type: "button",
      open: false,
      demo: true,
      items: [
        {
          name: "Mine Sites",
          visible: (user, project) => {
            return checkPermission({ permission: 'locations.mineSites.canView', permissions: user?.role?.permissions }) && isSelectedProject(user)
          },
          icon: "AimOutlined",
          type: "link",
          path: "/app/cadd/scl",
          demo: true,
          subPath: [
            "/app/cadd/scl/:id",
            '/app/cadd/analysis/scl/:id',
            '/app/cadd/analysis/scl/:id/:sourceId',

            "/app/cadd/view/scl/:id",
            "/app/cadd/view/scl/:id/:group",
            "/app/cadd/view/scl/:id/:group/:subsection",
            "/app/cadd/view/scl/:id/:group/:subsection/:subgroup",
            "/app/cadd/view/scl/:id/:group/:subsection/:subgroup/:formid",

            "/app/cadd/edit/scl/:id",
            "/app/cadd/edit/scl/:id/:group",
            "/app/cadd/edit/scl/:id/:group/:subsection",
            "/app/cadd/edit/scl/:id/:group/:subsection/:subgroup",
            "/app/cadd/edit/scl/:id/:group/:subsection/:subgroup/:formid",
          ]
        },
        {
          name: "Villages",
          visible: (user, project) => {
            return checkPermission({ permission: 'locations.villages.canView', permissions: user?.role?.permissions }) && isSelectedProject(user)
          },
          icon: "HomeOutlined",
          type: "link",
          path: "/app/cadd/village",
          demo: true,
          subPath: [
            "/app/cadd/village/:id",

            "/app/cadd/view/village/:id",
            "/app/cadd/view/village/:id/:group",
            "/app/cadd/view/village/:id/:group/:subsection",
            "/app/cadd/view/village/:id/:group/:subsection/:subgroup",
            "/app/cadd/view/village/:id/:group/:subsection/:subgroup/:formid",

            "/app/cadd/edit/village/:id",
            "/app/cadd/edit/village/:id/:group",
            "/app/cadd/edit/village/:id/:group/:subsection",
            "/app/cadd/edit/village/:id/:group/:subsection/:subgroup",
            "/app/cadd/edit/village/:id/:group/:subsection/:subgroup/:formid",
          ]
        },
        {
          name: "Other",
          visible: (user, project) => {
            return checkPermission({ permission: 'locations.canView', permissions: user?.role?.permissions }) && isSelectedProject(user)
          },
          icon: "GlobalOutlined",
          type: "link",
          path: "/app/cadd/locations",
          demo: true,
          subPath: [
            "/app/cadd/locations/:id",

            "/app/cadd/view/location/:id",
            "/app/cadd/view/location/:id/:group",
            "/app/cadd/view/location/:id/:group/:subsection",
            "/app/cadd/view/location/:id/:group/:subsection/:subgroup",
            "/app/cadd/view/location/:id/:group/:subsection/:subgroup/:formid",

            "/app/cadd/edit/location/:id",
            "/app/cadd/edit/location/:id/:group",
            "/app/cadd/edit/location/:id/:group/:subsection",
            "/app/cadd/edit/location/:id/:group/:subsection/:subgroup",
            "/app/cadd/edit/location/:id/:group/:subsection/:subgroup/:formid",
          ]
        },
      ]
    },
    {
      isModule: true,
      name: "Events",
      isModule: true,
      visible: (user, project) => {
        return checkPermission({ permission: 'events.canView', permissions: user?.role?.permissions }) && isSelectedProject(user)
      },
      icon: "DashboardEvents",
      type: "button",
      open: false,
      demo: true,
      items: [
        {
          name: "Incidents",
          visible: (user, project) => {
            return checkPermission({ permission: 'events.incidents.canView', permissions: user?.role?.permissions }) && isSelectedProject(user)
          },
          icon: "FireOutlined",
          type: "link",
          demo: true,
          path: "/app/cadd/incidents",
          subPath: [
            "/app/cadd/incidents/:id",

            "/app/cadd/view/incidents/:id",
            "/app/cadd/view/incidents/:id/:group",
            "/app/cadd/view/incidents/:id/:group/:subsection",
            "/app/cadd/view/incidents/:id/:group/:subsection/:subgroup",
            "/app/cadd/view/incidents/:id/:group/:subsection/:subgroup/:formid",

            "/app/cadd/edit/incidents/:id",
            "/app/cadd/edit/incidents/:id/:group",
            "/app/cadd/edit/incidents/:id/:group/:subsection",
            "/app/cadd/edit/incidents/:id/:group/:subsection/:subgroup",
            "/app/cadd/edit/incidents/:id/:group/:subsection/:subgroup/:formid",
          ],
        },
        {
          name: "Corrective Actions",
          visible: (user, project) => {
            return checkPermission({ permission: 'events.correctiveActions.canView', permissions: user?.role?.permissions }) && isSelectedProject(user)
          },
          icon: "ToolOutlined",
          type: "link",
          demo: true,
          path: "/app/cadd/corrective-actions",
          subPath: [
            "/app/cadd/corrective-actions/:id",

            "/app/cadd/view/corrective-actions/:id",
            "/app/cadd/view/corrective-actions/:id/:group",
            "/app/cadd/view/corrective-actions/:id/:group/:subsection",
            "/app/cadd/view/corrective-actions/:id/:group/:subsection/:subgroup",
            "/app/cadd/view/corrective-actions/:id/:group/:subsection/:subgroup/:formid",

            "/app/cadd/edit/corrective-actions/:id",
            "/app/cadd/edit/corrective-actions/:id/:group",
            "/app/cadd/edit/corrective-actions/:id/:group/:subsection",
            "/app/cadd/edit/corrective-actions/:id/:group/:subsection/:subgroup",
            "/app/cadd/edit/corrective-actions/:id/:group/:subsection/:subgroup/:formid",
          ],
        },
        {
          name: "All Events",
          visible: (user, project) => {
            return checkPermission({ permission: 'events.canView', permissions: user?.role?.permissions }) && isSelectedProject(user)
          },
          icon: "FlagOutlined",
          type: "link",
          demo: true,
          path: "/app/cadd/events",
          subPath: [
            "/app/cadd/event/:id",

            "/app/cadd/view/event/:id",
            "/app/cadd/view/event/:id/:group",
            "/app/cadd/view/event/:id/:group/:subsection",
            "/app/cadd/view/event/:id/:group/:subsection/:subgroup",
            "/app/cadd/view/event/:id/:group/:subsection/:subgroup/:formid",

            "/app/cadd/edit/event/:id",
            "/app/cadd/edit/event/:id/:group",
            "/app/cadd/edit/event/:id/:group/:subsection",
            "/app/cadd/edit/event/:id/:group/:subsection/:subgroup",
            "/app/cadd/edit/event/:id/:group/:subsection/:subgroup/:formid",
          ],
        },
      ]
    },
    {
      name: "Documents",
      isModule: true,
      visible: (user, project) => {
        return checkPermission({ permission: 'documents.canView', permissions: user?.role?.permissions });
      },
      icon: "DashboardDocuments",
      type: "button",
      items: [
        {
          name: "Due Diligence",
          visible: (user, project) => {
            return checkPermission({ permission: 'documents.canView', permissions: user?.role?.permissions }) && project && project.id ? true : false
          },
          demo: true,
          icon: "NodeIndexOutlined",
          type: "link",
          path: '/app/cadd/due-diligence',
          subPath: [
            "/app/cadd/view/kyc/:id",
            "/app/cadd/view/kyc/:id/:group",
            "/app/cadd/view/kyc/:id/:group/:subsection",
            "/app/cadd/view/kyc/:id/:group/:subsection/:subgroup",

            "/app/cadd/viewdd/sp/:id",
            "/app/cadd/viewdd/sp/:id/:group",
            "/app/cadd/viewdd/sp/:id/:group/:subsection",
            "/app/cadd/viewdd/sp/:id/:group/:subsection/:subgroup",

            "/app/cadd/viewdd/im/:id",
            "/app/cadd/viewdd/im/:id/:group",
            "/app/cadd/viewdd/im/:id/:group/:subsection",
            "/app/cadd/viewdd/im/:id/:group/:subsection/:subgroup",

            "/app/cadd/viewdd/bpe/:id",
            "/app/cadd/viewdd/bpe/:id/:group",
            "/app/cadd/viewdd/bpe/:id/:group/:subsection",
            "/app/cadd/viewdd/bpe/:id/:group/:subsection/:subgroup",

            "/app/cadd/viewdd/gm/:id",
            "/app/cadd/viewdd/gm/:id/:group",
            "/app/cadd/viewdd/gm/:id/:group/:subsection",
            "/app/cadd/viewdd/gm/:id/:group/:subsection/:subgroup",
          ]
        },
        {
          name: "All Documents",
          visible: (user, project) => {
            return checkPermission({ permission: 'documents.canView', permissions: user?.role?.permissions }) && project && project.id ? false : true
          },
          demo: true,
          icon: "TeamOutlined",
          type: "link",
          path: "/app/cadd/documents",
          subPath: [
            "/app/cadd/documents/:id",

            "/app/cadd/viewdd/document/:id",
            "/app/cadd/viewdd/document/:id/:group",
            "/app/cadd/viewdd/document/:id/:group/:subsection",
            "/app/cadd/viewdd/document/:id/:group/:subsection/:subgroup",
            "/app/cadd/viewdd/document/:id/:group/:subsection/:subgroup/:formid",

            "/app/cadd/editdd/document/:id",
            "/app/cadd/editdd/document/:id/:group",
            "/app/cadd/editdd/document/:id/:group/:subsection",
            "/app/cadd/editdd/document/:id/:group/:subsection/:subgroup",
            "/app/cadd/editdd/document/:id/:group/:subsection/:subgroup/:formid",
          ]
        },
        {
          name: "Other",
          visible: (user, project) => {
            return checkPermission({ permission: 'documents.canView', permissions: user?.role?.permissions }) && project && project.id ? true : false
          },
          demo: true,
          icon: "TeamOutlined",
          type: "link",
          path: "/app/cadd/documents",
          subPath: [
            "/app/cadd/documents/:id",

            "/app/cadd/viewdd/document/:id",
            "/app/cadd/viewdd/document/:id/:group",
            "/app/cadd/viewdd/document/:id/:group/:subsection",
            "/app/cadd/viewdd/document/:id/:group/:subsection/:subgroup",
            "/app/cadd/viewdd/document/:id/:group/:subsection/:subgroup/:formid",

            "/app/cadd/editdd/document/:id",
            "/app/cadd/editdd/document/:id/:group",
            "/app/cadd/editdd/document/:id/:group/:subsection",
            "/app/cadd/editdd/document/:id/:group/:subsection/:subgroup",
            "/app/cadd/editdd/document/:id/:group/:subsection/:subgroup/:formid",
          ]
        },

      ],
      demo: true,
      path: "/app/cadd/documents",
      subPath: [
        "/app/cadd/documents/:id",
        "/app/cadd/viewdd/document/:id/:group/:subsection/:subgroup",
        "/app/cadd/editdd/document/:id/:group/:subsection/:subgroup/:formid",
        "/app/cadd/view/kyc/:id/:group/:subsection/:subgroup",
        "/app/cadd/viewdd/sp/:id/:group/:subsection/:subgroup",
        "/app/cadd/viewdd/im/:id/:group/:subsection/:subgroup",
        "/app/cadd/viewdd/bpe/:id/:group/:subsection/:subgroup",
        "/app/cadd/viewdd/gm/:id/:group/:subsection/:subgroup",
      ]
    },
    {
      name: "Settings",
      path: "/app/cadd/view/settings",
      icon: "Settings",
      visible: (user) => { return true },
      isSettings: true,
      demo: true,
      type: "link",
    },
    {
      name: "Store",
      visible: (user, project) => {
        // return checkPermission({ permission: 'dataStore.canView', permissions: user?.role?.permissions }) && (!project || !project.id) ? true : false;
        return true;
      },
      icon: "DataStore",
      type: "link",
      demo: true,
      path: "/app/cadd/data-store",
      subPath: [
        '/app/cadd/data-store/:namespace',
        '/app/cadd/data-store/:namespace/view',
        '/app/cadd/data-store/:namespace/view/:id',
        '/app/cadd/data-store/:namespace/view/:id/:group',
      ]
    },
    {
      name: "Query",
      visible: (user, project) => {
        // return checkPermission({ permission: 'marketPlace.canView', permissions: user?.role?.permissions }) && (!project || !project.id) ? true : false;
        return true;
      },
      demo: true,
      type: "link",
      icon: "Query",
      path: "/app/cadd/find-information",
      subPath: [
        '/app/cadd/find-information/:id',
        '/app/cadd/find-information/:id/:sourceId',
      ]
    },
    {
      name: "Channels",
      visible: (user, project) => {
        return true;
      },
      demo: true,
      icon: "InformationChannels",
      type: "link",
      path: "/app/cadd/information-channels",
      subPath: [
        '/app/cadd/information-channels/:id',
        '/app/cadd/information-channels/:id/:subjectId',
        '/app/cadd/information-channels/:id/:subjectId/:dataPointId',
      ]
    },
  ],
  pme: [
    {
      name: 'My Organisation',
      visible: (user, project) => {
        return checkPermission({ permission: 'myOrganisation.canView', permissions: user?.role?.permissions }) && (!project || !project.id) ? true : false;
      },
      isModule: true,
      icon: "DashboardOwnOrg",
      type: "button",
      open: false,
      demo: true,
      items: [
        {
          name: "KYC",
          visible: (user, project) => {
            return checkPermission({ permission: 'myOrganisation.KYC.canView', permissions: user?.role?.permissions }) && (!project || !project.id) ? true : false;
          },
          isDisabled: (user, project) => {
            return !(project || project?.id);
          },
          demo: true,
          icon: "TeamOutlined",
          type: "link",
          path: '/app/pme/view/kyc/user',
          subPath: [
            "/app/pme/view/kyc/user/:id",
            '/app/pme/analysis/kyc',
            "/app/pme/edit/kyc/user/:id",
            "/app/pme/view/kyc/:id/:group?/:subsection?/:subgroup?",
            "/app/pme/edit/kyc/:id/:group?/:subsection?/:subgroup?",
          ]
        },
        // {
        //   name: "Shipments",
        //   icon: "BarcodeOutlined",
        //   visible: (user, project) => {
        //     return (!project || !project.id)
        //   },
        //   isDisabled: (user) => {
        //     return true;
        //   },
        //   path: "/app/pme/shipments",
        //   type: "link"
        // },
      ]
    },
    {
      name: "Dashboard Title",
      icon: "DashboardDashboard",
      visible: (user) => {
        return checkPermission({ permission: 'dashboard.canView', permissions: user?.role?.permissions })
      },
      path: "/app/pme",
      isDashboard: true,
      demo: true,
      type: "link",
    },
    {
      isModule: true,
      name: 'Stakeholders',
      visible: (user, project) => {
        return checkPermission({ permission: 'stakeholders.canView', permissions: user?.role?.permissions }) && isSelectedProject(user)
      },
      icon: "DashboardStakeholder",
      type: "button",
      open: false,
      demo: true,
      items: [
        {
          name: "Supply Chain Actors",
          visible: (user, project) => {
            return checkPermission({ permission: 'stakeholders.SCA.canView', permissions: user?.role?.permissions }) && isSelectedProject(user)
          },
          demo: true,
          icon: "NodeIndexOutlined",
          type: "link",
          path: "/app/pme/scp",
          subPath: [
            "/app/pme/scp/:id",
            "/app/pme/scp/:id/locations",

            '/app/pme/analysis/scp/:id',
            '/app/pme/analysis/scp/:id/:sourceId',

            "/app/pme/view/scp/:id",
            "/app/pme/view/scp/:id/:group",
            "/app/pme/view/scp/:id/:group/:subsection",
            "/app/pme/view/scp/:id/:group/:subsection/:subgroup",
            "/app/pme/view/scp/:id/:group/:subsection/:subgroup/:formid",

            "/app/pme/edit/scp/:id",
            "/app/pme/edit/scp/:id/:group",
            "/app/pme/edit/scp/:id/:group/:subsection",
            "/app/pme/edit/scp/:id/:group/:subsection/:subgroup",
            "/app/pme/edit/scp/:id/:group/:subsection/:subgroup/:formid",
          ]
        },
        {
          name: "Local Information Relays",
          visible: (user, project) => {
            return checkPermission({ permission: 'stakeholders.LIR.canView', permissions: user?.role?.permissions }) && isSelectedProject(user)
          },
          demo: true,
          icon: "EyeOutlined",
          type: "link",
          path: "/app/pme/lir",
          subPath: [
            "/app/pme/lir/:id",

            "/app/pme/view/lir/:id",
            "/app/pme/view/lir/:id/:group",
            "/app/pme/view/lir/:id/:group/:subsection",
            "/app/pme/view/lir/:id/:group/:subsection/:subgroup",
            "/app/pme/view/lir/:id/:group/:subsection/:subgroup/:formid",

            "/app/pme/edit/lir/:id",
            "/app/pme/edit/lir/:id/:group",
            "/app/pme/edit/lir/:id/:group/:subsection",
            "/app/pme/edit/lir/:id/:group/:subsection/:subgroup",
            "/app/pme/edit/lir/:id/:group/:subsection/:subgroup/:formid",
          ]
        },
        {
          name: "Other",
          visible: (user, project) => {
            return checkPermission({ permission: 'stakeholders.canView', permissions: user?.role?.permissions }) && isSelectedProject(user)
          },
          demo: true,
          icon: "TeamOutlined",
          type: "link",
          path: "/app/pme/stakeholders",
          subPath: [
            "/app/pme/stakeholders/:id",

            "/app/pme/view/stakeholder/:id",
            "/app/pme/view/stakeholder/:id/:group",
            "/app/pme/view/stakeholder/:id/:group/:subsection",
            "/app/pme/view/stakeholder/:id/:group/:subsection/:subgroup",
            "/app/pme/view/stakeholder/:id/:group/:subsection/:subgroup/:formid",

            "/app/pme/edit/stakeholder/:id",
            "/app/pme/edit/stakeholder/:id/:group",
            "/app/pme/edit/stakeholder/:id/:group/:subsection",
            "/app/pme/edit/stakeholder/:id/:group/:subsection/:subgroup",
            "/app/pme/edit/stakeholder/:id/:group/:subsection/:subgroup/:formid",
          ]
        },
      ]
    },
    {
      isModule: true,
      name: 'Locations',
      visible: (user, project) => {
        return checkPermission({ permission: 'locations.canView', permissions: user?.role?.permissions }) && isSelectedProject(user)
      },
      icon: "DashboardLocations",
      type: "button",
      open: false,
      demo: true,
      items: [
        {
          name: "Mine Sites",
          visible: (user, project) => {
            return checkPermission({ permission: 'locations.mineSites.canView', permissions: user?.role?.permissions }) && isSelectedProject(user)
          },
          icon: "AimOutlined",
          type: "link",
          path: "/app/pme/scl",
          demo: true,
          subPath: [
            "/app/pme/scl/:id",
            '/app/pme/analysis/scl/:id',
            '/app/pme/analysis/scl/:id/:sourceId',

            "/app/pme/view/scl/:id",
            "/app/pme/view/scl/:id/:group",
            "/app/pme/view/scl/:id/:group/:subsection",
            "/app/pme/view/scl/:id/:group/:subsection/:subgroup",
            "/app/pme/view/scl/:id/:group/:subsection/:subgroup/:formid",

            "/app/pme/edit/scl/:id",
            "/app/pme/edit/scl/:id/:group",
            "/app/pme/edit/scl/:id/:group/:subsection",
            "/app/pme/edit/scl/:id/:group/:subsection/:subgroup",
            "/app/pme/edit/scl/:id/:group/:subsection/:subgroup/:formid",
          ]
        },
        {
          name: "Villages",
          visible: (user, project) => {
            return checkPermission({ permission: 'locations.villages.canView', permissions: user?.role?.permissions }) && isSelectedProject(user)
          },
          icon: "HomeOutlined",
          type: "link",
          path: "/app/pme/village",
          demo: true,
          subPath: [
            "/app/pme/village/:id",

            "/app/pme/view/village/:id",
            "/app/pme/view/village/:id/:group",
            "/app/pme/view/village/:id/:group/:subsection",
            "/app/pme/view/village/:id/:group/:subsection/:subgroup",
            "/app/pme/view/village/:id/:group/:subsection/:subgroup/:formid",

            "/app/pme/edit/village/:id",
            "/app/pme/edit/village/:id/:group",
            "/app/pme/edit/village/:id/:group/:subsection",
            "/app/pme/edit/village/:id/:group/:subsection/:subgroup",
            "/app/pme/edit/village/:id/:group/:subsection/:subgroup/:formid",
          ]
        },
        {
          name: "Other",
          visible: (user, project) => {
            return checkPermission({ permission: 'locations.canView', permissions: user?.role?.permissions }) && isSelectedProject(user)
          },
          icon: "GlobalOutlined",
          type: "link",
          path: "/app/pme/locations",
          demo: true,
          subPath: [
            "/app/pme/locations/:id",

            "/app/pme/edit/location/:id",
            "/app/pme/edit/location/:id/:group",
            "/app/pme/edit/location/:id/:group/:subsection",
            "/app/pme/edit/location/:id/:group/:subsection/:subgroup",
            "/app/pme/edit/location/:id/:group/:subsection/:subgroup/:formid",

            "/app/pme/view/location/:id",
            "/app/pme/view/location/:id/:group",
            "/app/pme/view/location/:id/:group/:subsection",
            "/app/pme/view/location/:id/:group/:subsection/:subgroup",
            "/app/pme/view/location/:id/:group/:subsection/:subgroup/:formid",
          ]
        },
      ]
    },
    {
      isModule: true,
      name: "Events",
      visible: (user, project) => {
        return checkPermission({ permission: 'events.canView', permissions: user?.role?.permissions }) && isSelectedProject(user)
      },
      icon: "DashboardEvents",
      type: "button",
      open: false,
      demo: true,
      items: [
        {
          name: "Incidents",
          visible: (user, project) => {
            return checkPermission({ permission: 'events.incidents.canView', permissions: user?.role?.permissions }) && isSelectedProject(user)
          },
          icon: "FireOutlined",
          type: "link",
          demo: true,
          path: "/app/pme/incidents",
          subPath: [
            "/app/pme/incidents/:id",

            "/app/pme/view/incidents/:id",
            "/app/pme/view/incidents/:id/:group",
            "/app/pme/view/incidents/:id/:group/:subsection",
            "/app/pme/view/incidents/:id/:group/:subsection/:subgroup?",
            "/app/pme/view/incidents/:id/:group/:subsection/:subgroup/:formid",

            "/app/pme/edit/incidents/:id",
            "/app/pme/edit/incidents/:id/:group",
            "/app/pme/edit/incidents/:id/:group/:subsection",
            "/app/pme/edit/incidents/:id/:group/:subsection/:subgroup?",
            "/app/pme/edit/incidents/:id/:group/:subsection/:subgroup/:formid",
          ],
        },
        {
          name: "Corrective Actions",
          visible: (user, project) => {
            return checkPermission({ permission: 'events.correctiveActions.canView', permissions: user?.role?.permissions }) && isSelectedProject(user)
          },
          icon: "ToolOutlined",
          type: "link",
          demo: true,
          path: "/app/pme/corrective-actions",
          subPath: [
            "/app/pme/corrective-actions/:id",

            "/app/pme/view/corrective-actions/:id",
            "/app/pme/view/corrective-actions/:id/:group",
            "/app/pme/view/corrective-actions/:id/:group/:subsection",
            "/app/pme/view/corrective-actions/:id/:group/:subsection/:subgroup",
            "/app/pme/view/corrective-actions/:id/:group/:subsection/:subgroup/:formid",

            "/app/pme/edit/corrective-actions/:id",
            "/app/pme/edit/corrective-actions/:id/:group",
            "/app/pme/edit/corrective-actions/:id/:group/:subsection",
            "/app/pme/edit/corrective-actions/:id/:group/:subsection/:subgroup",
            "/app/pme/edit/corrective-actions/:id/:group/:subsection/:subgroup/:formid",
          ],
        },
        {
          name: "All Events",
          visible: (user, project) => {
            return checkPermission({ permission: 'events.canView', permissions: user?.role?.permissions }) && isSelectedProject(user)
          },
          icon: "FlagOutlined",
          type: "link",
          demo: true,
          path: "/app/pme/events",
          subPath: [
            "/app/pme/event/:id",

            "/app/pme/view/event/:id",
            "/app/pme/view/event/:id/:group",
            "/app/pme/view/event/:id/:group/:subsection",
            "/app/pme/view/event/:id/:group/:subsection/:subgroup",
            "/app/pme/view/event/:id/:group/:subsection/:subgroup/:formid",

            "/app/pme/edit/event/:id",
            "/app/pme/edit/event/:id/:group",
            "/app/pme/edit/event/:id/:group/:subsection",
            "/app/pme/edit/event/:id/:group/:subsection/:subgroup",
            "/app/pme/edit/event/:id/:group/:subsection/:subgroup/:formid",
          ],
        },
      ]
    },
    {
      isModule: true,
      name: "Documents",
      visible: (user, project) => {
        return checkPermission({ permission: 'documents.canView', permissions: user?.role?.permissions });
      },
      icon: "DashboardDocuments",
      type: "button",
      items: [
        {
          name: "Due Diligence",
          visible: (user, project) => {
            return checkPermission({ permission: 'documents.canView', permissions: user?.role?.permissions }) && project && project.id ? true : false
          },
          demo: true,
          icon: "NodeIndexOutlined",
          type: "link",
          path: '/app/pme/due-diligence',
          subPath: [
            "/app/pme/view/kyc/:id",
            "/app/pme/view/kyc/:id/:group",
            "/app/pme/view/kyc/:id/:group/:subsection",
            "/app/pme/view/kyc/:id/:group/:subsection/:subgroup",
            "/app/pme/viewdd/sp/:id",
            "/app/pme/viewdd/sp/:id/:group",
            "/app/pme/viewdd/sp/:id/:group/:subsection",
            "/app/pme/viewdd/sp/:id/:group/:subsection/:subgroup",
            "/app/pme/viewdd/im/:id",
            "/app/pme/viewdd/im/:id/:group",
            "/app/pme/viewdd/im/:id/:group/:subsection",
            "/app/pme/viewdd/im/:id/:group/:subsection/:subgroup",
            "/app/pme/viewdd/bpe/:id",
            "/app/pme/viewdd/bpe/:id/:group",
            "/app/pme/viewdd/bpe/:id/:group/:subsection",
            "/app/pme/viewdd/bpe/:id/:group/:subsection/:subgroup",
            "/app/pme/viewdd/gm/:id",
            "/app/pme/viewdd/gm/:id/:group",
            "/app/pme/viewdd/gm/:id/:group/:subsection",
            "/app/pme/viewdd/gm/:id/:group/:subsection/:subgroup",
          ]
        },
        {
          name: "All Documents",
          visible: (user, project) => {
            return checkPermission({ permission: 'documents.canView', permissions: user?.role?.permissions }) && project && project.id ? false : true
          },
          demo: true,
          icon: "TeamOutlined",
          type: "link",
          path: "/app/pme/documents",
          subPath: [
            "/app/pme/documents/:id",

            "/app/pme/viewdd/document/:id",
            "/app/pme/viewdd/document/:id/:group",
            "/app/pme/viewdd/document/:id/:group/:subsection",
            "/app/pme/viewdd/document/:id/:group/:subsection/:subgroup",

            "/app/pme/editdd/document/:id",
            "/app/pme/editdd/document/:id/:group",
            "/app/pme/editdd/document/:id/:group/:subsection",
            "/app/pme/editdd/document/:id/:group/:subsection/:subgroup",
          ]
        },
        {
          name: "Other",
          visible: (user, project) => {
            return checkPermission({ permission: 'documents.canView', permissions: user?.role?.permissions }) && project && project.id ? true : false
          },
          demo: true,
          icon: "TeamOutlined",
          type: "link",
          path: "/app/pme/documents",
          subPath: [
            "/app/pme/documents/:id",

            "/app/pme/viewdd/document/:id",
            "/app/pme/viewdd/document/:id/:group",
            "/app/pme/viewdd/document/:id/:group/:subsection",
            "/app/pme/viewdd/document/:id/:group/:subsection/:subgroup",

            "/app/pme/editdd/document/:id",
            "/app/pme/editdd/document/:id/:group",
            "/app/pme/editdd/document/:id/:group/:subsection",
            "/app/pme/editdd/document/:id/:group/:subsection/:subgroup",
          ],
        },

      ],
      demo: true,
      path: "/app/pme/documents",
      subPath: [
        "/app/pme/documents/:id",
        "/app/pme/viewdd/document/:id/:group/:subsection/:subgroup",
        "/app/pme/editdd/document/:id/:group/:subsection/:subgroup/:formid",
        "/app/pme/view/kyc/:id/:group/:subsection/:subgroup",
        "/app/pme/viewdd/sp/:id/:group/:subsection/:subgroup",
        "/app/pme/viewdd/im/:id/:group/:subsection/:subgroup",
        "/app/pme/viewdd/bpe/:id/:group/:subsection/:subgroup",
        "/app/pme/viewdd/gm/:id/:group/:subsection/:subgroup",
      ]
    },
    {
      name: "Settings",
      path: "/app/pme/view/settings",
      icon: "Settings",
      visible: (user) => { return true },
      isSettings: true,
      demo: true,
      type: "link",
    },
    {
      name: "Store",
      visible: (user, project) => {
        // return checkPermission({ permission: 'dataStore.canView', permissions: user?.role?.permissions }) && (!project || !project.id) ? true : false;
        return true;
      },
      icon: "DataStore",
      type: "link",
      demo: true,
      path: "/app/pme/data-store",
      subPath: [
        '/app/pme/data-store/:namespace',
        '/app/pme/data-store/:namespace/view',
        '/app/pme/data-store/:namespace/view/:id',
        '/app/pme/data-store/:namespace/view/:id/:group',
      ]
    },
    {
      name: "Query",
      visible: (user, project) => {
        // return checkPermission({ permission: 'marketPlace.canView', permissions: user?.role?.permissions }) && (!project || !project.id) ? true : false;
        return true;
      },
      demo: true,
      type: "link",
      icon: "Query",
      path: "/app/pme/find-information",
      subPath: [
        '/app/pme/find-information/:id',
        '/app/pme/find-information/:id/:sourceId',
      ]
    },
    {
      name: "Channels",
      visible: (user, project) => {
        return true;
      },
      demo: true,
      icon: "InformationChannels",
      type: "link",
      path: "/app/pme/information-channels",
      subPath: [
        '/app/pme/information-channels/:id',
        '/app/pme/information-channels/:id/:subjectId',
        '/app/pme/information-channels/:id/:subjectId/:dataPointId',
      ]
    },
  ],
  admin: [
    {
      name: "Dashboard Title",
      icon: "DashboardDashboard",
      visible: (user) => {
        return checkPermission({ permission: 'dashboard.canView', permissions: user?.role?.permissions });
      },
      path: "/app/admin",
      type: "link",
      isDashboard: true,
    },
    {
      name: "Users",
      icon: "Users",
      visible: () => { return true },
      path: "/app/admin/users",
      type: "link",
    },
    {
      name: "Subjects",
      icon: "Subjects",
      visible: () => { return true },
      type: "button",
      items: [
        {
          name: "Locations",
          icon: "EnvironmentOutlined",
          visible: () => { return true },
          path: "/app/admin/update/locations",
          type: "link",
        },
        {
          name: "Stakeholders",
          icon: "DeploymentUnitOutlined",
          visible: () => { return true },
          path: "/app/admin/update/stakeholders",
          type: "link",
        },
        {
          name: "Events",
          icon: "DeploymentUnitOutlined",
          visible: () => { return true },
          path: "/app/admin/update/events",
          type: "link",
        },
        {
          name: "LIR",
          icon: "ApartmentOutlined",
          visible: () => { return true },
          path: "/app/admin/update/lir",
          type: "link",
        },
      ]
    },
    {
      name: "Administrative Levels",
      icon: "DashboardLocations",
      visible: () => { return true },
      type: "button",
      items: [
        {
          name: "Level 1",
          icon: "GlobalOutlined",
          visible: () => { return true },
          path: "/app/admin/update/administrativeLevel1",
          type: "link",
        },
        {
          name: "Level 2",
          icon: "GlobalOutlined",
          visible: () => { return true },
          path: "/app/admin/update/administrativeLevel2",
          type: "link",
        },
        {
          name: "Level 3",
          icon: "GlobalOutlined",
          visible: () => { return true },
          path: "/app/admin/update/administrativeLevel3",
          type: "link",
        },
        {
          name: "Level 4",
          icon: "GlobalOutlined",
          visible: () => { return true },
          path: "/app/admin/update/administrativeLevel4",
          type: "link",
        },
        {
          name: "Level 5",
          icon: "GlobalOutlined",
          visible: () => { return true },
          path: "/app/admin/update/administrativeLevel5",
          type: "link",
        },
      ]
    },
    {
      name: "Settings",
      path: "/app/admin/view/settings",
      icon: "Settings",
      visible: (user) => { return true },
      isSettings: true,
      demo: true,
      type: "link",
    },
  ],
  tif: [
    {
      name: "Dashboard Title",
      icon: "TifDashboard",
      visible: (user) => {
        return checkPermission({ permission: 'dashboard.canView', permissions: user?.role?.permissions })
      },
      path: "/app/tif",
      isDashboard: true,
      demo: true,
      type: "link",
    },
    {
      name: "KYC",
      path: '/app/tif/analysis/kyc/user',
      visible: (user, project) => {
        const mod = getTifModule(user);
        return mod === 'cadd' && checkPermission({ permission: 'myOrganisation.KYC.canView', permissions: user?.role?.permissions }) && (!project || !project.id) ? true : false;
      },
      isDisabled: (user, project) => {
        return !(project || project?.id);
      },
      type: "link",
      isModule: true,
      icon: "KYC",
      subPath: [
        "/app/tif/view/kyc/user/:id",
        '/app/tif/analysis/kyc',
        "/app/tif/view/kyc/:id",
        "/app/tif/view/kyc/:id/:group",
        "/app/tif/view/kyc/:id/:group/:subsection",
        "/app/tif/view/kyc/:id/:group/:subsection/:subgroup",
        "/app/tif/edit/kyc/:id",
        "/app/tif/edit/kyc/:id/:group",
        "/app/tif/edit/kyc/:id/:group/:subsection",
        "/app/tif/edit/kyc/:id/:group/:subsection/:subgroup",
      ]
    },
    {
      name: "AMP",
      visible: (user, project) => {
        return checkPermission({ permission: 'amp.canView', permissions: user?.role?.permissions }) && (!project || !project.id) ? true : false;
      },
      icon: "TifAmp",
      type: "link",
      path: "/app/tif/amp",
      demo: true,
      isModule: true,
      subPath: [
        "/app/tif/amp/:id",
        '/app/tif/analysis/amp/:id',
        '/app/tif/analysis/amp/:id/:sourceId',
        "/app/tif/view/amp/:id",
        "/app/tif/view/amp/:id/:group",
        "/app/tif/view/amp/:id/:group/:subsection",
        "/app/tif/view/amp/:id/:group/:subsection/:subgroup",
        "/app/tif/view/amp/:id/:group/:subsection/:subgroup/:formid",
        "/app/tif/edit/amp/:id",
        "/app/tif/edit/amp/:id/:group",
        "/app/tif/edit/amp/:id/:group/:subsection",
        "/app/tif/edit/amp/:id/:group/:subsection/:subgroup",
        "/app/tif/edit/amp/:id/:group/:subsection/:subgroup/:formid",

        "/app/tif/view/mine-profile/:id",
        "/app/tif/view/mine-profile/:id/:group",
        "/app/tif/view/mine-profile/:id/:group/:subsection",
        "/app/tif/view/mine-profile/:id/:group/:subsection/:subgroup",
        "/app/tif/view/mine-profile/:id/:group/:subsection/:subgroup/:formid",
        "/app/tif/edit/mine-profile/:id/:group",
        "/app/tif/edit/mine-profile/:id/:group/:subsection",
        "/app/tif/edit/mine-profile/:id/:group/:subsection/:subgroup",
        "/app/tif/edit/mine-profile/:id/:group/:subsection/:subgroup/:formid",

        "/app/tif/view/ownership-kyc/:id/:group",
        "/app/tif/view/ownership-kyc/:id/:group/:subsection",
        "/app/tif/view/ownership-kyc/:id/:group/:subsection/:subgroup",
        "/app/tif/view/ownership-kyc/:id/:group/:subsection/:subgroup/:formid",
        "/app/tif/edit/ownership-kyc/:id/:group",
        "/app/tif/edit/ownership-kyc/:id/:group/:subsection",
        "/app/tif/edit/ownership-kyc/:id/:group/:subsection/:subgroup",
        "/app/tif/edit/ownership-kyc/:id/:group/:subsection/:subgroup/:formid",

        "/app/tif/view/esg-assessment/:id/:group",
        "/app/tif/view/esg-assessment/:id/:group/:subsection",
        "/app/tif/view/esg-assessment/:id/:group/:subsection/:subgroup",
        "/app/tif/view/esg-assessment/:id/:group/:subsection/:subgroup/:formid",
        "/app/tif/edit/esg-assessment/:id/:group",
        "/app/tif/edit/esg-assessment/:id/:group/:subsection",
        "/app/tif/edit/esg-assessment/:id/:group/:subsection/:subgroup",
        "/app/tif/edit/esg-assessment/:id/:group/:subsection/:subgroup/:formid",
      ]
    },
    {
      name: "Application Form",
      visible: (user, project) => {
        return (checkPermission({ permission: 'applicationForm.canView', permissions: user?.role?.permissions }) && (!project || !project.id) ? true : false) && !['assessment', 'preAssessed', 'review'].includes(user?.amp?.status);
      },
      icon: "ApplicationForm",
      type: "link",
      path: "/app/tif/view/application-form/user",
      demo: true,
      isModule: true,
      subPath: [
        "/app/tif/view/application-form/:id",
        "/app/tif/view/application-form/:id/:group",
        "/app/tif/view/application-form/:id/:group/:subsection",
        "/app/tif/view/application-form/:id/:group/:subsection/:subgroup",
        "/app/tif/view/application-form/:id/:group/:subsection/:subgroup/:formid",
        "/app/tif/edit/application-form/:id",
        "/app/tif/edit/application-form/:id/:group",
        "/app/tif/edit/application-form/:id/:group/:subsection",
        "/app/tif/edit/application-form/:id/:group/:subsection/:subgroup",
        "/app/tif/edit/application-form/:id/:group/:subsection/:subgroup/:formid",
      ]
    },
    {
      name: "Mine Profile",
      visible: (user, project) => {
        return (checkPermission({ permission: 'applicationForm.canView', permissions: user?.role?.permissions }) && (!project || !project.id) ? true : false) && ['assessment', 'preAssessed', 'review'].includes(user?.amp?.status);
      },
      icon: "MineProfile",
      type: "link",
      path: "/app/tif/view/mine-profile/user",
      demo: true,
      isModule: true,
      subPath: [
        "/app/tif/view/mine-profile/:id",
        "/app/tif/view/mine-profile/:id/:group",
        "/app/tif/view/mine-profile/:id/:group/:subsection",
        "/app/tif/view/mine-profile/:id/:group/:subsection/:subgroup",
        "/app/tif/view/mine-profile/:id/:group/:subsection/:subgroup/:formid",
        "/app/tif/edit/mine-profile/:id",
        "/app/tif/edit/mine-profile/:id/:group",
        "/app/tif/edit/mine-profile/:id/:group/:subsection",
        "/app/tif/edit/mine-profile/:id/:group/:subsection/:subgroup",
        "/app/tif/edit/mine-profile/:id/:group/:subsection/:subgroup/:formid",
      ]
    },
    {
      name: "KYC",
      visible: (user, project) => {
        return (checkPermission({ permission: 'applicationForm.canView', permissions: user?.role?.permissions }) && (!project || !project.id) ? true : false) && ['assessment', 'preAssessed', 'review'].includes(user?.amp?.status);
      },
      icon: "OwnershipKYC",
      type: "link",
      path: "/app/tif/view/ownership-kyc/user",
      demo: true,
      isModule: true,
      subPath: [
        "/app/tif/view/ownership-kyc/:id",
        "/app/tif/view/ownership-kyc/:id/:group",
        "/app/tif/view/ownership-kyc/:id/:group/:subsection",
        "/app/tif/view/ownership-kyc/:id/:group/:subsection/:subgroup",
        "/app/tif/view/ownership-kyc/:id/:group/:subsection/:subgroup/:formid",
        "/app/tif/edit/ownership-kyc/:id",
        "/app/tif/edit/ownership-kyc/:id/:group",
        "/app/tif/edit/ownership-kyc/:id/:group/:subsection",
        "/app/tif/edit/ownership-kyc/:id/:group/:subsection/:subgroup",
        "/app/tif/edit/ownership-kyc/:id/:group/:subsection/:subgroup/:formid",
      ]
    },
    {
      name: "ESG Analysis",
      visible: (user, project) => {
        return false;
      },
      icon: "ESGPerformance",
      type: "link",
      demo: true,
      isDisabled: true,
      isModule: true,
    },
    {
      name: "Programs",
      path: "/app/tif/programs",
      visible: (user, project) => {
        // if (user?.role?.code === tifRoles.AMP) {
        //   return !['registered', 'applied', 'application'].includes(user?.amp?.status || user?.amp?.ampStatus);
        // }

        return checkPermission({ permission: 'programs.canView', permissions: user?.role?.permissions }) && (!project || !project.id) ? true : false;
      },
      icon: "Programs",
      type: "link",
      demo: true,
      isAnalysis: true, subPath: [
        '/app/tif/analysis/programs/:id',
        '/app/tif/analysis/programs/:id/:sourceId',

        "/app/tif/view/programs/:id",
        "/app/tif/view/programs/:id/:group",
        "/app/tif/view/programs/:id/:group/:subsection",
        "/app/tif/view/programs/:id/:group/:subsection/:subgroup",
        "/app/tif/view/programs/:id/:group/:subsection/:subgroup/:formid",
        "/app/tif/edit/programs/:id",
        "/app/tif/edit/programs/:id/:group",
        "/app/tif/edit/programs/:id/:group/:subsection",
        "/app/tif/edit/programs/:id/:group/:subsection/:subgroup",
        "/app/tif/edit/programs/:id/:group/:subsection/:subgroup/:formid",
      ]
    },
    {
      name: "Production",
      path: "/app/tif/production",
      visible: (user, project) => {
        if (user?.role?.code === tifRoles.AMP) {
          return !['registered', 'applied', 'application'].includes(user?.amp?.status || user?.amp?.ampStatus);
        }

        return checkPermission({ permission: 'production.canView', permissions: user?.role?.permissions }) && (!project || !project.id) ? true : false;
      },
      icon: "ProductionReports",
      type: "link",
      demo: true,
      isDisabled: true,
      isModule: true,
    },
    {
      name: "Settings",
      path: "/app/tif/view/settings",
      icon: "Settings",
      visible: (user) => { return true },
      isSettings: true,
      demo: true,
      type: "link",
    },
    {
      name: "Store",
      visible: (user, project) => {
        if (user?.role?.code === tifRoles.AMP) {
          return !['registered', 'applied', 'application'].includes(user?.amp?.status || user?.amp?.ampStatus);
        }

        return checkPermission({ permission: 'dataStore.canView', permissions: user?.role?.permissions }) && (!project || !project.id) ? true : false;
      },
      icon: "DataStore",
      type: "link",
      demo: true,
      path: "/app/tif/data-store",
      subPath: [
        '/app/tif/data-store/:namespace',
        '/app/tif/data-store/:namespace/view',
        '/app/tif/data-store/:namespace/view/:id',
        '/app/tif/data-store/:namespace/view/:id/:group',
      ]
    },
    {
      name: "Query",
      visible: (user, project) => {
        if (user?.role?.code === tifRoles.AMP) {
          return !['registered', 'applied', 'application'].includes(user?.amp?.status || user?.amp?.ampStatus);
        }

        return checkPermission({ permission: 'marketPlace.canView', permissions: user?.role?.permissions }) && (!project || !project.id) ? true : false;
      },
      demo: true,
      type: "link",
      icon: "Query",
      path: "/app/tif/find-information",
      subPath: [
        '/app/tif/find-information/:id',
        '/app/tif/find-information/:id/:sourceId',
      ]
    },
    {
      name: "Channels",
      visible: (user, project) => {
        if (user?.role?.code === tifRoles.AMP) {
          return !['registered', 'applied', 'application'].includes(user?.amp?.status || user?.amp?.ampStatus);
        }

        return true; // TODO: fix this
      },
      demo: true,
      icon: "InformationChannels",
      type: "link",
      path: "/app/tif/information-channels",
      subPath: [
        '/app/tif/information-channels/:id',
        '/app/tif/information-channels/:id/:subjectId',
        '/app/tif/information-channels/:id/:subjectId/:dataPointId',
      ]
    },
  ],
  tazama: [
    {
      name: "Dashboard Title",
      icon: "TifDashboard",
      visible: (user) => {
        return checkPermission({ permission: 'dashboard.canView', permissions: user?.role?.permissions })
      },
      path: "/app/tazama",
      isDashboard: true,
      demo: true,
      type: "link",
    },
    {
      isModule: true,
      name: "Main Information",
      visible: (user, project) => {
        // return checkPermission({ permission: 'events.canView', permissions: user?.role?.permissions }) && isSelectedProject(user)
        return true;
      },
      icon: "DashboardEvents",
      type: "button",
      open: false,
      demo: true,
      items: [
        {
          name: "Incidents",
          visible: (user, project) => {
            // return checkPermission({ permission: 'events.incidents.canView', permissions: user?.role?.permissions }) && isSelectedProject(user)
            return true;
          },
          icon: "FireOutlined",
          type: "link",
          demo: true,
          path: "/app/tazama/incidents",
          subPath: [
            "/app/tazama/incidents/:id",

            "/app/tazama/view/incidents/:id",
            "/app/tazama/view/incidents/:id/:group",
            "/app/tazama/view/incidents/:id/:group/:subsection",
            "/app/tazama/view/incidents/:id/:group/:subsection/:subgroup?",
            "/app/tazama/view/incidents/:id/:group/:subsection/:subgroup/:formid",

            "/app/tazama/edit/incidents/:id",
            "/app/tazama/edit/incidents/:id/:group",
            "/app/tazama/edit/incidents/:id/:group/:subsection",
            "/app/tazama/edit/incidents/:id/:group/:subsection/:subgroup?",
            "/app/tazama/edit/incidents/:id/:group/:subsection/:subgroup/:formid",
          ],
        },
        {
          name: "Corrective Actions",
          visible: (user, project) => {
            // return checkPermission({ permission: 'events.correctiveActions.canView', permissions: user?.role?.permissions }) && isSelectedProject(user)
            return true;
          },
          icon: "ToolOutlined",
          type: "link",
          demo: true,
          path: "/app/tazama/corrective-actions",
          subPath: [
            "/app/tazama/corrective-actions/:id",

            "/app/tazama/view/corrective-actions/:id",
            "/app/tazama/view/corrective-actions/:id/:group",
            "/app/tazama/view/corrective-actions/:id/:group/:subsection",
            "/app/tazama/view/corrective-actions/:id/:group/:subsection/:subgroup",
            "/app/tazama/view/corrective-actions/:id/:group/:subsection/:subgroup/:formid",

            "/app/tazama/edit/corrective-actions/:id",
            "/app/tazama/edit/corrective-actions/:id/:group",
            "/app/tazama/edit/corrective-actions/:id/:group/:subsection",
            "/app/tazama/edit/corrective-actions/:id/:group/:subsection/:subgroup",
            "/app/tazama/edit/corrective-actions/:id/:group/:subsection/:subgroup/:formid",
          ],
        },
        {
          name: "Testimonials",
          visible: (user, project) => {
            // return checkPermission({ permission: 'events.correctiveActions.canView', permissions: user?.role?.permissions }) && isSelectedProject(user)
            return true; // TODO: fix this
          },
          icon: "ToolOutlined",
          type: "link",
          demo: true,
          path: "/app/tazama/testimonials",
          subPath: [
            "/app/tazama/testimonials/:id",

            "/app/tazama/view/testimonials/:id",
            "/app/tazama/view/testimonials/:id/:group",
            "/app/tazama/view/testimonials/:id/:group/:subsection",
            "/app/tazama/view/testimonials/:id/:group/:subsection/:subgroup",
            "/app/tazama/view/testimonials/:id/:group/:subsection/:subgroup/:formid",

            "/app/tazama/edit/testimonials/:id",
            "/app/tazama/edit/testimonials/:id/:group",
            "/app/tazama/edit/testimonials/:id/:group/:subsection",
            "/app/tazama/edit/testimonials/:id/:group/:subsection/:subgroup",
            "/app/tazama/edit/testimonials/:id/:group/:subsection/:subgroup/:formid",
          ],
        },
      ]
    },
    {
      isModule: true,
      name: "Associated Information",
      visible: (user, project) => {
        // return checkPermission({ permission: 'events.canView', permissions: user?.role?.permissions }) && isSelectedProject(user)
        return true;
      },
      icon: "LinkedSubjects",
      type: "button",
      open: false,
      demo: true,
      items: [
        {
          name: "Initiatives",
          visible: (user, project) => {
            // return checkPermission({ permission: 'events.initiatives.canView', permissions: user?.role?.permissions }) && isSelectedProject(user)
            return true;
          },
          icon: "FireOutlined",
          type: "link",
          demo: true,
          path: "/app/tazama/initiatives",
          subPath: [
            "/app/tazama/initiatives/:id",

            "/app/tazama/view/initiatives/:id",
            "/app/tazama/view/initiatives/:id/:group",
            "/app/tazama/view/initiatives/:id/:group/:subsection",
            "/app/tazama/view/initiatives/:id/:group/:subsection/:subgroup?",
            "/app/tazama/view/initiatives/:id/:group/:subsection/:subgroup/:formid",

            "/app/tazama/edit/initiatives/:id",
            "/app/tazama/edit/initiatives/:id/:group",
            "/app/tazama/edit/initiatives/:id/:group/:subsection",
            "/app/tazama/edit/initiatives/:id/:group/:subsection/:subgroup?",
            "/app/tazama/edit/initiatives/:id/:group/:subsection/:subgroup/:formid",
          ],
        },
        {
          name: "individualsSidebar",
          visible: (user, project) => {
            // return checkPermission({ permission: 'events.victims.canView', permissions: user?.role?.permissions }) && isSelectedProject(user)
            return true;
          },
          icon: "ToolOutlined",
          type: "link",
          demo: true,
          path: "/app/tazama/victims",
          subPath: [
            "/app/tazama/victims/:id",

            "/app/tazama/view/victims/:id",
            "/app/tazama/view/victims/:id/:group",
            "/app/tazama/view/victims/:id/:group/:subsection",
            "/app/tazama/view/victims/:id/:group/:subsection/:subgroup",
            "/app/tazama/view/victims/:id/:group/:subsection/:subgroup/:formid",

            "/app/tazama/edit/victims/:id",
            "/app/tazama/edit/victims/:id/:group",
            "/app/tazama/edit/victims/:id/:group/:subsection",
            "/app/tazama/edit/victims/:id/:group/:subsection/:subgroup",
            "/app/tazama/edit/victims/:id/:group/:subsection/:subgroup/:formid",
          ],
        },
        {
          name: "Locations",
          visible: (user, project) => {
            // return checkPermission({ permission: 'locations.canView', permissions: user?.role?.permissions }) && isSelectedProject(user)
            return true;
          },
          icon: "FlagOutlined",
          type: "link",
          demo: true,
          path: "/app/tazama/locations",
          subPath: [
            "/app/tazama/location/:id",

            "/app/tazama/view/location/:id",
            "/app/tazama/view/location/:id/:group",
            "/app/tazama/view/location/:id/:group/:subsection",
            "/app/tazama/view/location/:id/:group/:subsection/:subgroup",
            "/app/tazama/view/location/:id/:group/:subsection/:subgroup/:formid",

            "/app/tazama/edit/location/:id",
            "/app/tazama/edit/location/:id/:group",
            "/app/tazama/edit/location/:id/:group/:subsection",
            "/app/tazama/edit/location/:id/:group/:subsection/:subgroup",
            "/app/tazama/edit/location/:id/:group/:subsection/:subgroup/:formid",
          ],
        },
        {
          name: "Stakeholders",
          visible: (user, project) => {
            // return checkPermission({ permission: 'stakeholders.canView', permissions: user?.role?.permissions }) && isSelectedProject(user)
            return true;
          },
          icon: "FlagOutlined",
          type: "link",
          demo: true,
          path: "/app/tazama/stakeholders",
          subPath: [
            "/app/tazama/stakeholder/:id",

            "/app/tazama/view/stakeholder/:id",
            "/app/tazama/view/stakeholder/:id/:group",
            "/app/tazama/view/stakeholder/:id/:group/:subsection",
            "/app/tazama/view/stakeholder/:id/:group/:subsection/:subgroup",
            "/app/tazama/view/stakeholder/:id/:group/:subsection/:subgroup/:formid",

            "/app/tazama/edit/stakeholder/:id",
            "/app/tazama/edit/stakeholder/:id/:group",
            "/app/tazama/edit/stakeholder/:id/:group/:subsection",
            "/app/tazama/edit/stakeholder/:id/:group/:subsection/:subgroup",
            "/app/tazama/edit/stakeholder/:id/:group/:subsection/:subgroup/:formid",
          ],
        },
        {
          name: "Pictures",
          visible: (user, project) => {
            // return checkPermission({ permission: 'pictures.canView', permissions: user?.role?.permissions }) && isSelectedProject(user)
            return true;
          },
          icon: "FlagOutlined",
          type: "link",
          demo: true,
          path: "/app/tazama/pictures",
          subPath: [
            "/app/tazama/pictures/:id",

            "/app/tazama/view/pictures/:id",
            "/app/tazama/view/pictures/:id/:group",
            "/app/tazama/view/pictures/:id/:group/:subsection",
            "/app/tazama/view/pictures/:id/:group/:subsection/:subgroup",
            "/app/tazama/view/pictures/:id/:group/:subsection/:subgroup/:formid",
          ],
        },
        {
          name: "Documents",
          visible: (user, project) => {
            // return checkPermission({ permission: 'documents.canView', permissions: user?.role?.permissions }) && isSelectedProject(user)
            return true;
          },
          icon: "FlagOutlined",
          type: "link",
          demo: true,
          path: "/app/tazama/documents",
          subPath: [
            "/app/tazama/document/:id",

            "/app/tazama/view/documents/:id",
            "/app/tazama/view/documents/:id/:group",
            "/app/tazama/view/documents/:id/:group/:subsection",
            "/app/tazama/view/documents/:id/:group/:subsection/:subgroup",
            "/app/tazama/view/documents/:id/:group/:subsection/:subgroup/:formid",
          ],
        },
      ]
    },
    {
      name: "Store",
      visible: (user, project) => {
        if (user?.role?.code === tifRoles.AMP) {
          return !['registered', 'applied', 'application'].includes(user?.amp?.status || user?.amp?.ampStatus);
        }

        // return checkPermission({ permission: 'dataStore.canView', permissions: user?.role?.permissions }) && (!project || !project.id) ? true : false;
        return true;
      },
      icon: "DataStore",
      type: "link",
      demo: true,
      path: "/app/tazama/data-store",
      subPath: [
        '/app/tazama/data-store/:namespace',
        '/app/tazama/data-store/:namespace/view',
        '/app/tazama/data-store/:namespace/view/:id',
        '/app/tazama/data-store/:namespace/view/:id/:group',
      ]
    },
    {
      name: "Query",
      visible: (user, project) => {
        if (user?.role?.code === tifRoles.AMP) {
          return !['registered', 'applied', 'application'].includes(user?.amp?.status || user?.amp?.ampStatus);
        }

        // return checkPermission({ permission: 'marketPlace.canView', permissions: user?.role?.permissions }) && (!project || !project.id) ? true : false;
        return true;
      },
      demo: true,
      type: "link",
      icon: "Query",
      path: "/app/tazama/find-information",
      subPath: [
        '/app/tazama/find-information/:id',
        '/app/tazama/find-information/:id/:sourceId',
      ]
    },
    {
      name: "Channels",
      visible: (user, project) => {
        if (user?.role?.code === tifRoles.AMP) {
          return !['registered', 'applied', 'application'].includes(user?.amp?.status || user?.amp?.ampStatus);
        }

        return true; // TODO: fix this
      },
      demo: true,
      icon: "InformationChannels",
      type: "link",
      path: "/app/tazama/information-channels",
      subPath: [
        '/app/tazama/information-channels/:id',
        '/app/tazama/information-channels/:id/:subjectId',
        '/app/tazama/information-channels/:id/:subjectId/:dataPointId',
      ]
    },
  ],
};

export default config;
